var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9043 14.0565L8.13535 14.0421L17.3702 4.89541C17.7326 4.53299 17.9321 4.05169 17.9321 3.53971C17.9321 3.02772 17.7326 2.54642 17.3702 2.184L15.8496 0.663394C15.1248 -0.0614366 13.8602 -0.0576016 13.1411 0.660518L3.9043 9.80911V14.0565ZM14.4939 2.0191L16.0174 3.53683L14.4862 5.05361L12.9656 3.53395L14.4939 2.0191ZM5.82184 10.6087L11.6032 4.88199L13.1238 6.4026L7.34341 12.1274L5.82184 12.1322V10.6087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9859 17.879H15.4087C16.4662 17.879 17.3262 17.0189 17.3262 15.9614V7.6508L15.4087 9.56834V15.9614H5.0137C4.98877 15.9614 4.96288 15.971 4.93796 15.971C4.90632 15.971 4.87468 15.9624 4.84208 15.9614H1.9859V2.53864H8.5506L10.4681 0.621094H1.9859C0.928377 0.621094 0.0683594 1.48111 0.0683594 2.53864V15.9614C0.0683594 17.0189 0.928377 17.879 1.9859 17.879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit_button.ad471e586b3670ddb4edf7412feac845.svg";
export { ForwardRef as ReactComponent };